export class GameHudIcons extends Phaser.GameObjects.Container {
  constructor(scene, config) {
    super(scene);
    scene.add.existing(this);
    this.icons = config.map((entry) => {
      const icon = scene.add.image(0, 0, entry.icon.sheet, entry.icon.frame).setOrigin(0, 0.5);
      icon.config = entry;
      this.add(icon);
      return icon;
    });
  }

  updateDisplay(buttons, settings) {
    let width = 0;
    let height = 0;
    this.icons.forEach((icon) => {
      icon.visible = true;
      if (icon.config.hideOnButton) {
        const hide = icon.config.hideOnButton.find((h) => buttons.includes(h));
        icon.visible = hide ? false : true;
      }
      if (icon.visible && icon.config.showOnSetting) {
        icon.visible =
          settings.getSettingValue(icon.config.showOnSetting.setting) ===
          icon.config.showOnSetting.value;
      }
      icon.x = width;
      if (icon.visible) {
        width += 20 + icon.width;
        height = Math.max(icon.height, height);
      }
    });
    this._displayWidth = width;
    this._displayHeight = height;
  }

  get displayWidth() {
    return this._displayWidth;
  }
  get displayHeight() {
    return this._displayHeight;
  }
}
